import { Component, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { EnvConfigurationService } from 'src/app/service/env-config.service';

@Component({
  selector: 'app-sensorstation-aqdm-dashboard',
  templateUrl: './sensorstation-aqdm-dashboard.component.html',
  styleUrl: './sensorstation-aqdm-dashboard.component.scss',
  standalone: false,
})
export class SensorstationAqdmDashboardComponent implements OnInit, OnDestroy {
  public url: string;

  private resizeListener: () => void;

  constructor(
    public envService: EnvConfigurationService,
    private elementRef: ElementRef
  ) {
    const currentTime = new Date();
    const referenceTime = new Date(
      currentTime.getFullYear(),
      currentTime.getMonth(),
      currentTime.getDate(),
      currentTime.getHours() - 3,
      0,
      0,
      0 //
    );

    const from = referenceTime.getTime();
    const to = from + 3600000;
    const pollutant = 'no2'; // default

    this.url = `${envService.config.sensorstationAQDM}&from=${from}&to=${to}&pollutant=${pollutant}`;
  }

  ngOnInit(): void {
    this.setIframeHeights();
    this.resizeListener = this.updateIframeHeights.bind(this);
    window.addEventListener('resize', this.resizeListener);
  }

  private setIframeHeights(): void {
    this.updateIframeHeights();
  }

  private updateIframeHeights(): void {
    const iframe = this.elementRef.nativeElement.querySelector(
      '#sensorstation-aqdm'
    ) as HTMLIFrameElement;

    if (!iframe) {
      return;
    }

    const viewportHeight =
      window.innerHeight ||
      document.documentElement.clientHeight ||
      document.body.clientHeight;

    // Calculate how far the iframe is from the top of the viewport
    const topOffset = iframe.getBoundingClientRect().top;

    // Stretch the iframe so its bottom touches the bottom of the viewport
    iframe.style.height = `${viewportHeight - topOffset - 69}px`;
  }

  ngOnDestroy(): void {
    if (this.resizeListener) {
      window.removeEventListener('resize', this.resizeListener);
    }
  }
}
